export const SEED_USERS = [];
export const SEED_LMS_COURSES = [];
export const SEED_LMS_SUBMISSIONS = [];
export const SEED_LMS_ANNOUNCEMENTS = [];
export const SEED_LMS_TIMETABLE = [];
